module.exports = __webpack_public_path__ + "img/delivery.e5734221.png";